import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  if (sent) {
    return (
      <div data-testid="forgot-password-sent" className="max-w-[520px] mx-auto px-6 py-24 text-center">
        <MailCheck size={44} className="mx-auto" style={{ color: "#1E3A2B" }} />
        <h1 className="font-display text-4xl tracking-tighter mt-5">Check your inbox.</h1>
        <p className="mt-4 text-neutral-500">
          If that email is registered with us, we've sent a password reset link. It expires in one hour.
        </p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/auth" className="btn-primary" data-testid="forgot-back-signin">Back to sign in</Link>
          <button className="btn-outline" data-testid="forgot-try-again" onClick={() => setSent(false)}>
            Use a different email
          </button>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="forgot-password-page" className="max-w-[520px] mx-auto px-6 py-16">
      <div className="label-eyebrow">Account recovery</div>
      <h1 className="font-display text-5xl tracking-tighter mt-3">Forgot your password?</h1>
      <p className="mt-4 text-neutral-500">
        Enter the email you signed up with and we'll send you a link to set a new password.
      </p>

      <form onSubmit={submit} className="hairline mt-6 p-8 space-y-4">
        <div>
          <label className="label-eyebrow">Email</label>
          <input required type="email" data-testid="forgot-input-email"
            className="w-full mt-2 hairline p-3 text-sm bg-white outline-none focus:border-black"
            value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        {error && <div data-testid="forgot-error" className="text-sm text-red-600">{error}</div>}
        <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="forgot-submit">
          {loading ? "…" : "Send reset link"}
        </button>
      </form>

      <p className="mt-4 text-xs text-neutral-500">
        Remembered it?{" "}
        <Link className="underline" to="/auth" data-testid="forgot-signin-link">Sign in instead</Link>.
      </p>
    </div>
  );
}
